

export const formatDataForPieGrid = ({ data, idField }) => {
    const formattedData = [...data].map(item => {
        const { [idField]: id, ...rest } = item;
        return { id, ...rest };
    });
    const newFieldNames = Object.keys(formattedData[0]).filter(key => key !== 'id');
    return {data: formattedData, fieldNames: newFieldNames };
}
